import { z } from 'zod';

/**
 * Shape of the persistable subset of the forecast (Tasks) query.
 *
 * Shared by every localStorage round-trip of the query so the Tasks page
 * (useForecastQueryStorage) and Tasks Analytics (persistedAnalyticsState) cannot
 * drift apart when the query shape changes.
 */
export const forecastQuerySchema = z.object({
  projectIds: z.array(z.number()).optional(),
  userIds: z.array(z.number().nullable()).nullable().optional(),
  teamIds: z.array(z.number()).nullable().optional(),
  showCompleted: z.boolean().optional(),
  onlyShowProjectAssignees: z.boolean().optional(),
  since: z.string().nullable().optional(),
  until: z.string().nullable().optional(),
  dateSpan: z.enum(['day', 'week', 'month', 'custom']).optional(),
});

export type PersistableForecastQuery = z.infer<typeof forecastQuerySchema>;
